import { createSlice } from "@reduxjs/toolkit";

let storedUser = null;
try {
  storedUser = JSON.parse(localStorage.getItem("user"));
} catch {
  storedUser = null;
}

const initialState = {
  mode: "dark",
  token: localStorage.getItem("token") || null,
  user: storedUser,
  userId: storedUser?.id || storedUser?._id || null,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setCredentials: (state, action) => {
      const { user, token } = action.payload || {};
      state.user = user || null;
      state.token = token || null;
      state.userId = user?.id || user?._id || null;
      if (token) localStorage.setItem("token", token);
      if (user) localStorage.setItem("user", JSON.stringify(user));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.userId = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const { setMode, setCredentials, logout } = globalSlice.actions;

export default globalSlice.reducer;
